<pds-module-header title="Compras" ctaPath="/compras" ctaLabel="Voltar" ctabuttonType="primary" modifier="outlined">
  <pds-new-breadcrumb [items]="breadcrumb"></pds-new-breadcrumb>

  <ng-container *ngIf="order$ | async; let order">
    <ng-container *ngIf="order.loading">
      <strong>carregando...</strong>
    </ng-container>

    <ng-container *ngIf="order.failure">
      <peca-retry context="detalhes da ordem de compra" (retry)="onRetry()" />
    </ng-container>

    <ng-container *ngIf="!order.loading && !order.failure && order.data">
      <div class="order-details-card">
        <div class="order-details-card__header">
          <div class="order-details-card__header__col --part-number">{{ order.data.order?.commerceReference }}</div>
          <div class="order-details-card__header__col --status">
            <span pdsChip>{{ order.data.status | status }}</span>
          </div>
          <div class="order-details-card__header__col --datetime">{{ order.data.audit?.createdAt | date : 'dd/MM/yyyy HH:mm' }}</div>
          <div class="order-details-card__header__col --value">{{ order.data.amount | currency : 'BRL' }}</div>
        </div>

        <div class="order-details-card__content">
          <peca-purchase-order-details-summary [order]="order.data" />

          <pds-tabs [tabs]="tabs" (selected)="onTabSelected($event)">
            @if (useRouting) {
            <router-outlet />
            }@else {
            <ng-container *ngFor="let tab of tabs | keyvalue">
              @if (tab.value.active) { @if (tab.key === 'products') {
              <peca-purchase-order-details-products [orderId]="id" />
              }@else if(tab.key === 'logs'){
              <peca-purchase-order-details-logs [orderId]="id" />
              }@else if(tab.key === 'integrateLogs'){
              <peca-purchase-order-details-integrate-logs [orderId]="id" />
              } }
            </ng-container>
            }
          </pds-tabs>
        </div>
      </div>
      @if (showAddNfeButton) {
      <hr />

      <pds-form-actions>
        <button pdsButton (click)="onClickAssociation()">
          <span class="icon">attach_file</span>
          <p>Associar NF-e</p>
        </button>
        <button pdsButton (click)="onClickIntegrate()" [disabled]="!['WAITING_CONFIRMATION', 'CANCELED', 'REFUSED'].includes(order.data.status)">
          <span class="icon">sync</span>
          <p>Reintegrar</p>
        </button>
      </pds-form-actions>
      }
    </ng-container>
  </ng-container>
</pds-module-header>
<peca-purchase-order-modal-association-nf #modalAssociationNf (confirm)="associate($event)" />
